// extracted by mini-css-extract-plugin
module.exports = {"pageDescription":"page-description_pageDescription__6Ox6k"};